import React, { useState } from 'react';

import ViewUploads from '../Upload/ViewUploads';

import { defineTicketNumber } from '../../Helpers/helpers';
import CabinetDisplayInfo from '../CommonComponents/CabinetDisplayInfo';

import { Box, Grid, Typography, Button, Divider, Modal } from '@mui/material';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

const RepairHistoryView = (props) => {
  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => setOpen3(false);

  const ticketData = props.repair_ticket;

  const [useType, setUseType] = useState(localStorage.getItem('type'));

  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100%',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
        // overflow: 'scroll',
      }}
    >
      <Typography
        style={{
          background: '#354775',
          padding: '15px',
          border: 'solid 2px #354775',
          color: '#ffffff',
        }}
        variant='h5'
      >
        TICKET NR: {defineTicketNumber('repair', ticketData?.id, '5', 'R')}
      </Typography>

      <Box
        name='customerDetails'
        style={{
          minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Box>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Category:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_category_name}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Customer Name:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Address:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_address}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Branch Code:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_branchcode}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Contact Person:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_contact_name}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>WI Nr:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.wi_number}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Contact Number:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_contact_number}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Asset Comp:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.customer_asset_comp_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: '15px' }}>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Notify Me:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.notify_customer ? 'Yes' : 'No'}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Ticket Logged By:</Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoInfo}>
                {ticketData?.creator_name}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Divider />
      <Box
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoTitle}>
              Problem/Issue Reported:
            </Typography>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Typography
              style={ticketTypoInfo}
              size='small'
              sx={{
                width: '100%',
                padding: 0,
              }}
              required
              id='description'
            >
              {ticketData?.description}
            </Typography>
          </Grid>
        </Grid>
        <Typography variant='h6'>Logged Cabinets:</Typography>{' '}
        <Box>
          {ticketData?.serial_numbers.map((obj, index) => {
            return (
              <Box key={index} margin='10px'>
                <CabinetDisplayInfo
                  // customer={customer}
                  cabinetId={obj.id}
                  cabinetData={obj}
                />
                <Grid
                  container
                  xs={10}
                  md={10}
                  flexDirection='row'
                  rowGap={1}
                  // columnGap={1}
                  alignContent='flex-start'
                >
                  <Grid
                    sx={{ margin: '0 0 40px 0' }}
                    container
                    xs={1}
                    md={1}
                    flexDirection='row'
                    rowGap={1}
                    columnGap={1}
                    alignContent='flex-start'
                  ></Grid>
                </Grid>
                <Divider />
              </Box>
            );
          })}
        </Box>
      </Box>
      <Divider style={{ marginBottom: '15px' }} />
      <Box
        name='ticketDetails'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Box
          name='customerDetails'
          style={{
            minHeight: '20vh',
            maxWidth: '100%',
            textAlign: 'left',
            background: '#ebedf8',
            borderRadius: '5px',
            padding: '15px',
          }}
        >
          <Box>
            <Grid
              container
              sx={{ marginTop: '15px', textTransform: 'capitalize' }}
            >
              <Grid item xs={12} lg={3}>
                <Typography
                  style={ticketTypoTitle}
                  sx={{ textTransform: 'capitalize' }}
                >
                  Ticket Type:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {ticketData?.ticket_type}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>
                  Subcontractor Assigned:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {ticketData?.sub_assigned_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: '15px' }}>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>Tech Assigned:</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {ticketData?.tech_assigned_name}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>
                  Subcontractor Contact Nr:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {ticketData?.sub_assigned_number}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: '15px' }}>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>Assistant Tech:</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {ticketData?.assist_tech_assigned}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoTitle}>Customer:</Typography>
              </Grid>
              <Grid item xs={12} lg={3}>
                <Typography style={ticketTypoInfo}>
                  {ticketData?.sub_customer}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Divider />
      <Box
        style={{
          //   minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoTitle}>Status:</Typography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoInfo}>{ticketData?.status}</Typography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoTitle}>Cancel Reason:</Typography>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography style={ticketTypoInfo}>
              {ticketData?.cancel_reason}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Modal
        open={open3}
        onClose={handleClose3}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={uploadModalStyle}>
          <ViewUploads
            relationId={ticketData?.id}
            relationType='repairTickets'
          />
        </Box>
      </Modal>
      <Divider />
      <Box
        style={{
          //   minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'right',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Button
          sx={{ minWidth: '120px' }}
          // fullWidth
          variant='contained'
          color='btn_info'
          style={{
            margin: '15px 5px',
            fontWeight: '700',
          }}
          onClick={() => {
            handleOpen3();
          }}
        >
          View Docs
        </Button>
        {/* <Button
          sx={{ display: ticketData.cancel_reason !== '' && 'none' }}
          onClick={() => ticketUpdate()}
          variant='contained'
          color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
        >
          Re-open
        </Button> */}
        <Button
          onClick={props.close}
          variant='contained'
          //   color='success'
          style={{ margin: '15px 5px', fontWeight: '700' }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};
export default RepairHistoryView;

const uploadModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: '80vh',
  overflow: 'scroll',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
